import { render, staticRenderFns } from "./empty-bucket.vue?vue&type=template&id=de4e4b94&scoped=true"
import script from "./empty-bucket.vue?vue&type=script&lang=js"
export * from "./empty-bucket.vue?vue&type=script&lang=js"
import style0 from "./empty-bucket.vue?vue&type=style&index=0&id=de4e4b94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de4e4b94",
  null
  
)

export default component.exports